import { ContractsUserGroupsResponse } from 'api/endpoints';
import {
  AddFields,
  EditFieldsList,
  EntityTable,
  Panel,
} from 'components/UIComponents/EntityTable';
import { AwarePanel } from 'components/UIComponents/EntityTable/EntityTable.components';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { SettingsContentPanel } from 'pages/SettingsPage/components/SettingsContentPanel';
import { UserGroupInput } from './ContractUserGroupInput';
import '../claims/UserGroups.css';
import { useEditAndAddContractsUserGroups } from '../../hooks/useContractsUserGroups';

const HEADERS = ['Group name', 'Users', 'Categories'];
const COLUMN_KEYS: (keyof ContractsUserGroupsResponse)[] = [
  'name',
  'users',
  'contractCategories',
];

export function ContractUserGroups() {
  const { status, data, onAddSave, onEditSave, onDelete } =
    useEditAndAddContractsUserGroups();
  const userGroups = data ?? [];

  return (
    <SettingsContentPanel>
      <section className="usergroups">
        <EntityTable
          items={userGroups}
          status={status}
          addColumnKeys={COLUMN_KEYS}
          editColumnKeys={COLUMN_KEYS}
          inputComponent={UserGroupInput}
          onEditSave={onEditSave}
          onAddSave={onAddSave}
          section={SectionType.Contracts}
          onDelete={onDelete}
          hasDeleteRow
        >
          <Panel title="User group management">
            <AddFields headers={HEADERS} />
          </Panel>
          <AwarePanel title="Current user groups">
            <EditFieldsList headers={HEADERS} />
          </AwarePanel>
        </EntityTable>
      </section>
    </SettingsContentPanel>
  );
}
